export default {
  default: {
    portal: {
      nav: {
        home: '首頁',
        contactUs: '聯絡我們',
        contactUsUrl: 'https://www.chief.com.tw/demandform/',
        myAccount: '我的帳戶',
        login: '登入',
        logout: '登出',
        registerQuery: '註冊進度查詢',
        createAccount: '建立帳戶',
        lastestNews: '最新消息',
        products: '產品',
        productExtra1: '是方全球 BMC 雲服務',
        productExtra2: '是方CCIS Zone2',
        solution: '解決方案',
        solutionVpc: 'VPC是方虛擬私有網路',
        solutionCloud: 'CCIS是方儲存雲服務',
        solutionCount: 'VDS雲端虛擬主機',
        pricing: '定價',
        documentDownload: '註冊說明',
        webMap: '網站地圖',
        privacyRightDeclare: '隱私權聲明',
        personalProfileProtect: '個資保護',
        cookiePolicy: 'COOKIE政策',
        fraudPrevent: '詐騙防範',
        copyrightDeclare: '版權聲明',
        securityPolicy: '資訊安全政策',
        cloudDeclare: '雲服務聲明',
        summary: '概觀',
        functions: '功能',
      },
      header: {
        title: '是方電訊 CHIEF',
      },
      footer: {
        address: '是方電訊股份有限公司 臺北市114內湖區瑞光路68號2樓',
        telephone1: '070-1018-6688',
        telephone2: '02-2657-6688',
        copyright: 'COPYRIGHT@2020 CHIEF TELECOM INC. ALL RIGHTS RESERVED',
        facebook: 'Facebook',
        youtube: 'Youtube',
        line: 'Line',
        linkedIn: 'LinkedIn',
        cookieText1: '使用 Cookies 可以提升您的網站體驗，歡迎查看我們的',
        cookieText2: '以瞭解我們使用的 Cookies 設定。若您選擇「同意」，則表示允許我們使用 Cookies 記錄及存取您的資訊。若您選擇「拒絕」，我們仍會使用基本 Cookies 維持網站的運作。',
        agree: '同意', 
        reject: '拒絕',
      },
      pageHome: {
        title: '探索我們的解決方案',
        readMore: '瞭解更多',
      },
      pageLogin: {
        loginTypeRootLabel: 'root用戶的電子郵件地址',
        loginTypeRootDescription: '執行需要無限制訪問權限的任務的帳戶的擁有者。',
        loginTypeIAMLabel: 'IAM用戶',
        loginTypeIAMDescription: '在帳戶中執行日常任務的用戶。',
        forgetPassword: '忘記密碼',
        login: '登入',
        twoFATitle: '確認您的身份',
        twoFADescription1: '確保您的安全－這是我們的責任。',
        twoFADescription2: '我們已傳送一封內含驗證碼的電子郵件至',
        twoFADescription3: '。',
        twoFADescription4: '請在下方輸入驗證碼以確認您的電子郵件。',
        verify: '驗證',
        resendVerifyCode: '重新傳送驗證碼',
        notReceiveVerifyCodeTitle: '沒收到驗證碼？',
        notReceiveVerifyCodeDescription1: '您會在5分鐘內收到驗證碼。',
        notReceiveVerifyCodeDescription2: '請檢查您的垃圾郵件資料夾。',
        twoFARetrySuccess: '已經重新傳送驗證碼至{{email}}！', 
        formFields: {
          account: '根用戶電子郵件地址',
          password: '密碼',
          root: '客戶編碼(11位數)',
          iamAccount: '客戶帳號',
          tfa_code: '驗證碼',
        },
      },
      pageForgetPassword: {
        forgetPassword: '忘記密碼',
        resetPassword: '重設密碼',
        or: '或',
        login: '登入',
        successfully: '已發送重設密碼連結至',
        returnToHome: '返回首頁',
        formFields: {
          email: '主聯絡人Email',
        },
      },
      pageRegister: {
        registerAccount: '註冊帳戶',
        rootEmail: 'root 用戶的電子郵件地址',
        rootEmailNote: '用於帳戶恢復和一些管理功能',
        rootEmailLabel: '請輸入帳戶(email)',
        validateEmail: '驗證電子郵件地址',
        or: '或',
        login: '登入',
        successfully: '已發送驗證連結至',
        returnToHome: '返回首頁',
        formFields: {
          email: 'root 用戶的電子郵件地址',
        },
      },
      pageRegisterQuery: {
        registerQuery: '註冊進度查詢',
        validateEmail: '取得註冊進度資訊',
        or: '或',
        login: '登入',
        successfully: '已發送註冊查詢連結至',
        returnToHome: '返回首頁',
        formFields: {
          email: '主聯絡人Email',
        },
        queryProgress: '註冊進度',
        queryResult: {
          REGISTER_NOT_COMPLETED: '未完成註冊',
          REGISTER_UNDER_REVIEW: '審核中',
          REGISTER_DENIED: '已拒絕',
          REGISTER_COMPLETE: '已完成',
        },
      },
      pageRegisterInfoInput: {
        registerInfoInput: '註冊基本資料',
        basicData: '基本資料',
        contactInfo: '聯絡資訊',
        billInfo: '帳務資訊',
        fileUpload: '雙證上傳',
        supplyInfo: '補充資訊',
        basic: '必填',
        improved: '進階資訊',
        returnToHome: '回首頁',
        submit: '送出',
        reset: '重設',
        confirmUploadTitle: '確認送出',
        confirmUpload: '證件上傳不完整，是否確認資料送出？',
        successfully: '註冊資料已送出成功，請耐心等待審核！',
        companyNameNotify: '請與公司/組織 之登記證名稱一致, 否則可能導致註冊失敗.（若為個人註冊，本欄可不填）',
        formFields: {
          main_mail: '主聯絡人Email',
          identity_type: '性質',
          identity_number: '客戶統編/證號',
          company_name: '公司全名',
          company_shortname: '公司簡稱',
          en_company_name: '英文全名',
          en_company_shortname: '英文簡稱',
          company_owner: '負責人',
          contact_name: '主聯絡人',
          contact_mobile_code: '主聯絡人手機國際碼',
          contact_mobile: '主聯絡人聯繫號碼（開頭的0不可省略）',
          tech_contact_mail: '技術聯絡人Email',
          contact_tel_code: '主聯絡人公司電話國際碼',
          contact_tel: '主聯絡人公司電話號碼',
          contact_tel_ext: '主聯絡人公司電話分機',
          cman_dmfg: '主聯絡人DM寄送',
          bill_contact_name: '帳務聯絡人',
          bill_contact_tel_code: '帳務聯絡人公司電話國際碼',
          bill_contact_tel: '帳務聯絡人公司電話號碼',
          bill_contact_ext: '帳務聯絡人公司電話分機',
          bill_contact_mobile_code: '帳務聯絡人手機國際碼',
          bill_contact_mobile: '帳務聯絡人手機號碼',
          bill_dmfg: '帳務聯絡人DM寄送',
          bill_contact_mail: '帳務聯絡人Email',
          tech_contact_name: '技術聯絡人',
          tech_contact_tel_code: '技術聯絡人公司電話國際碼',
          tech_contact_tel: '技術聯絡人公司電話號碼',
          tech_contact_ext: '技術聯絡人公司電話分機',
          tech_contact_mobile_code: '技術聯絡人手機國際碼',
          tech_contact_mobile: '技術聯絡人手機號碼',
          tech_dmfg: '技術聯絡人DM寄送',
          currency_type: '幣別',
          language: '語系',
          industry_type: '行業別',
          bill_address: '帳單地址',
          is_foreign: '國內/國外',
          area: '區域',
          receipt_lottery_title: '發票抬頭',
          en_address: '英文地址',
          receipt_lottery_address: '發票地址',
          doc1: '身份證件一',
          doc2: '身份證件二',
          doc3: '身份證件三',
          doc4: '身份證件四',
          companyDoc3: '公司證件三',
          companyDoc4: '公司證件四',
          tel_code: '電話一國際碼',
          tel: '電話一號碼',
          tel_ext: '電話一分機',
          tel2_code: '電話一國際碼',
          tel2: '電話二號碼',
          tel2_ext: '電話二分機',
          tel3_code: '電話三國際碼',
          tel3: '電話三號碼',
          tel3_ext: '電話三分機',
          fax: '傳真一',
          fax2: '傳真二',
          fax3: '傳真三',
          mail: 'E-mail',
        },
        commercialNatureEnum: {
          'COMPANY': 'COMPANY',
          'PERSONAL': 'PERSONAL',
        },
        dmEnum: {
          'C': '中文版',
          'E': '英文版',
          'X': '不寄送',
        },
        industryTypeEnum: {
          '10': '其他',
          '11': '出版業',
          '12': '醫療及社服業',
          '20': '金融及保險業',
          '21': '半導體製造業',
          '22': '機械製造業',
          '23': '電子製造業',
          '24': '化工石化製造業',
          '25': '食品製造業',
          '26': '汽車零組件製造業',
          '27': '紡織製造業',
          '28': '其他製造業',
          '29': '醫藥醫材生技業',
          '30': '工商顧問服務業',
          '31': '政府機關',
          '32': '地方機構',
          '41': '媒體業',
          '50': '國外電信業者',
          '51': '國內電信業者',
          '52': '語音批售業',
          '53': '一般ICP業者',
          '55': '製造業',
          '56': '批發零售業',
          '57': '資訊及通訊傳播業',
          '58': '住宿及旅遊業',
          '59': '運輸倉儲業',
          '60': '教育補教業',
          '61': '休閒娛樂服務業',
          '62': '網際網路與雲業者',
        },
        isForeignEnum: {
          '0': '國內',
          '1': '國外',
        },
        areaEnum: {
          'TWNCENTRAL': '台灣中區',
          'TWNNORTH': '台灣北區',
          'TWNSOUTH': '台灣南區',
        },
        termsOfService: '服務條款\n\n一、認知與接受條款\n1. 是方電訊股份有限公司(以下簡稱「是方」)係依據本服務條款提供 Cloud Service Customer Portal 服務 (以下簡稱「本服務」)。當會員完成是方會員之註冊手續、或開始使用本服務時，即表示已閱讀、瞭解並同意接受本服務條款之所有內容，並完全接受本服務現有與未來衍生的服務項目及內容。是方有權隨時且於任何時間修改或變更本服務條款之內容，修改後的服務條款內容將公佈於相關網站上，是方將不會個別通知會員，建議會員隨時注意該等修改或變更。會員於任何修改或變更後繼續使用本服務時，視為會員已閱讀、瞭解並同意接受該等修改或變更。若不同意上述的服務條款修訂或更新方式，或不接受本服務條款的其他任一約定，會員應立即停止使用本服務。\n2. 若會員為未滿十八歲之未成年人或為未滿成年年齡之外國未成年人，應於會員的家長（或監護人）閱讀、瞭解並同意本約定書之所有內容及其後修改變更後，方得註冊為會員、使用或繼續使用本服務。當會員使用或繼續使用本服務時，即推定會員的家長（或監護人）已閱讀、瞭解並同意接受本約定書之所有內容及其後修改變更。\n3. 會員及是方雙方同意使用本服務之所有內容包括但不限於意思表示或通知等，以電子文件作為表示方式。\n4. 為保護您的個人資料，依據個人資料保護法第 8 條及相關適用之法令規定，告知有關是方電訊對於個人資料之蒐集、處理及利用等相關事項如下：\no 蒐集之目的：是方依據個人資料保護法及相關適用之法令規定，於最小必要目的範圍內，蒐集您的個人資料，為行銷、非公務機關依法定義務所進行個人資料之蒐集處理及利用、契約、類似契約或其他法律關係事務、消費者、客戶管理與服務、消費者保護、商業與技術資訊、廣告或商業行為之內部調查、統計與研究分析、或其他提供服務及業務之必要範圍。\no 蒐集之個人資料類別：是方電訊所蒐集您提供之資料，包含姓名、服務單位、部門、職稱、連絡方式，包括但不限於電話、傳真、E-MAIL、地址或其他得以直接或間接識別您個人之資料。\no 利用期間、地區、對象及方式：\n(1) 期間：於是方電訊公司存續期間、依法令規定之資料保存期間或因執行業務所必須之保存期間。\n(2) 地區：中華民國（台灣）領域內或利用對象之國內及國外所在地。\n(3) 對象：是方電訊、是方電訊母公司或子公司、對是方電訊具有控制關係或是方 電訊擁有一定比例以上的股份或具有實際控制關係之公司或（以下合稱是方電訊關係企業）、是方電訊之共同行銷或合作夥伴、其他與是方電訊有業務往來或合作之機構、主管機關、依法有調查權之機關、組織或團體。 \n(4) 方式：是方將僅於最小必要範圍內，以電話、簡訊、電子郵件、紙本或其他合於當時科學技術之適當方式蒐集、處理國際傳輸與利用個人資料。\no 會員就個人資料之權利\n(1) 請求查詢、閱覽或製給複製本，惟是方電訊依法得酌收必要成本費用。\n(2) 請求補充或更正之。\n(3) 個人資料蒐集之特定目的消失或期限屆滿時，向是方電訊請求刪除、停止處理或利用您的個人資料。但是方電訊因執行職務或業務所必須者，不在此限。\n(4) 是方電訊利用個人資料行銷，您表示拒絕接受行銷時，是方電訊將在合理期間後停止以行銷之名義利用您個人資料。\n(5) 如為設籍歐盟之個人得依據歐盟個人資料保護規則且在不妨礙是方電訊履行原說明使用目的、範圍內得行使下列相關權利：資料主體之接近使用權、資料更正權、資料刪除權（被遺忘權）、資料處理限制權、資料可攜權、資料拒絕權。\no 是方已設置資訊管理委員會作為個人資料保護之內部組織，專責人員電子信箱： tim_chiang@chief.com.tw。\no 請注意！如拒絕提供加入會員所需必要之資料，將可能導致無法享受完整服務或無法使用該項服務。\n\n二、會員的註冊義務\n為了能使用本服務，會員同意以下事項：\no	提供會員本人正確、最新的資料，且不得以第三人之名義註冊為會員。每位會員僅能註冊登錄一個帳號，不可重覆註冊登錄。\no	即時維持並更新會員個人資料，確保其正確性，以獲取最佳之服務。\no	若會員提供任何錯誤或不實的資料、或未按指示提供資料、或欠缺必要之資料、或有重覆註冊帳號等情事時，是方有權不經事先通知，逕行暫停或終止會員的帳號，並拒絕會員使用本服務之全部或一部。\n\n三、雲端服務收費、租用、到期、異動與終止\no	當會員使用本 Cloud Service Customer Portal 服務租用個別服務時，是方依會員租用之雲端運算、雲端儲存、相關網路及一次性建置費服務使用費進行收費，收費標準公告於本服務官方網站上。\no	雲端計量型服務計費以一個月為一期，實際使用未達一個月者，各項費用仍依照實際使用量進行收費。\no	雲端合約型服務計費依照約定之合約期間（例如最小租用期間）為主，會員若於服務租用期間屆滿前終止本服務者，除應清償已開立發票之應付服務費用之外，並應支付相當於是方在租用期間履行服務完畢原可收取之金額之全部。\no	是方將於每月五日前開立會員應繳費用之帳單向會員收取應付之費用，會員應依是方之通知，於收到請款通知當月十五日前以電匯或現金票給付，並將電匯水單影本以電子郵件或傳真予是方帳務聯絡人。通知郵寄地址以會員登載於是方客戶資料之地址者為準，會員如需變更郵寄地址時，應事先以書面或電子郵件通知是方後，郵寄地址變更始為生效。會員對費用計算明細有疑義者，應於收受請款通知日起算五日內檢具理由以書面或電子郵件方式通知是方，逾期視為會員完全接受，會員方應依約按期支付費用。雲端合約型服務啟用日至當月月底之月租費，則加入次月一日之預付請款一併計算請款。\no	所有雲端服務每月應收費用雙方同意依本服務上所列之費用結算；是方對各項費用價格得為調整，並應於調整生效日前一個月通知會員，於調整生效日起按調整後之價格收費。\no	所有雲端服務正式啟用後，會員應依本條第4項約定方式足額支付本服務所產生之費用。如會員逾期超過三日仍未支付足額款項時，是方有權逕予暫停或中止向會員提供服務，包括但不限於中止使用許可或停止操作授權等措施。\no	會員擬異動合約制型雲端服務時，須線上填具異動報修申請書，雲端服務異動須經是方同意後始得變動原申請服務項目內容，如因異動造成原租用服務金額變動，須加註增減金額與異動起始時間，並依基本服務項目與加值服務各單項收費規定辦理。\no	會員於合約制型雲端服務期間屆滿前 30 日未以書面或電子郵件方式通知是方不續租時，雲端服務自動依照原服務期間進行續約，其後亦同；於自動續約期間內，會員得於預定提前終止日前 30 日以書面或電子郵件方式通知是方，並於完成是方所訂之線上退租申請流程後，雲端服務於預定終止日當日終止提供。會員提前終止雲端服務時，除應清償已開立發票之應付服務費用外，並應支付相當於是方在自動續約期間履行服務完畢原可收取之金額之全部。\n\n四、隱私權政策\n關於會員的註冊以及其他特定資料依是方「隱私權政策」受到保護與規範。\n\n五、使用者的守法義務及承諾\n會員承諾絕不為任何非法目的或以任何非法方式使用本服務，並承諾遵守中華民國相關法規及一切使用網際網路之國際慣例。會員同意並保證不得利用本服務從事侵害他人權益或違法之行為，包括但不限於：\no	公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗或其他不法之文字、圖片或任何形式的檔案\no	侵害或毀損是方或他人名譽、隱私權、營業秘密、商標權、著作權、專利權、其他智慧財產權及其他權利\no	違反依法律或契約之行為或違背其所應負之保密義務\no	冒用他人名義使用本服務\no	傳輸或散佈電腦病毒\no	從事未經是方事前授權的商業行為\no	刊載、傳輸、發送垃圾郵件、連鎖信、違法或未經是方許可之多層次傳銷訊息及廣告等；或儲存任何侵害他人智慧財產權或違反法令之資料\no	對本服務其他用戶或第三人產生困擾、不悅致生反感之行為\no	其他不符本服務所提供的使用目的之行為或是方有正當理由認為不適當之行為\n\n六、服務內容之變更與電子報及 EDM 發送\no	會員同意是方所提供本服務之範圍，是方均得視業務需要及實際情形，增減、變更或終止相關服務的項目或內容，且無需個別通知會員。\no	會員同意是方得依實際執行情形，增加、修改或終止相關活動，並選擇最適方式告知會員。\no	會員同意是方得不定期發送電子報或商品訊息(EDM)至會員所登錄的電子信箱帳號。當會員收到訊息後表示拒絕接受行銷時，是方將停止繼續發送行銷訊息。\n\n七、服務之停止、中斷\n是方將依一般合理之技術及方式，維持系統及本服務之正常運作。但於以下各項情況時，是方有權可以停止、中斷提供本服務：\no	是方網站電子通信設備進行必要之保養及施工時\no	發生突發性之電子通信設備故障時\no	是方網站申請之電子通信服務被停止，無法提供服務時\no	由於天災等不可抗力之因素或其他不可歸責於是方致使是方網站無法提供服務時\n\n八、責任之限制與排除\no	本服務所提供之各項功能，均依該功能當時之現況提供使用，是方對於其效能、速度、完整性、可靠性、安全性、正確性等，皆不負擔任何明示或默示之擔保責任\no	是方並不保證本服務之網頁、伺服器、網域等所傳送的電子郵件或其內容不會含有電腦病毒等有害物；亦不保證郵件、檔案或資料之傳輸儲存均正確無誤不會斷線和出錯等，因各該郵件、檔案或資料傳送或儲存失敗、遺失或錯誤等所致之損害，是方不負賠償責任。\n\n九、智慧財產權的保護\no	是方所使用之軟體或程式、網站上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構、網站畫面的安排、網頁設計，均由是方或其他權利人依法擁有其智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。若會員欲引用或轉載前述軟體、程式或網站內容，必須依法取得是方或其他權利人的事前書面同意。尊重智慧財產權是會員應盡的義務，如有違反，會員應對是方負損害賠償責任（包括但不限於訴訟費用及律師費用等）。\no	在尊重他人智慧財產權之原則下，會員同意在使用是方之服務時，不作侵害他人智慧財產權之行為。\no	若會員有涉及侵權之情事，是方可暫停全部或部份之服務，或逕自以取消會員帳號之方式處理。\n\n十、會員對是方之授權\n除個人資料外，對於會員上載、傳送、輸入或提供之資料，會員同意是方網站得於合理之範圍內蒐集、處理、保存、傳遞及使用該等資料，以提供使用者其他資訊或服務、或作成會員統計資料、或進行關於網路行為之調查或研究，或為任何之合法使用。任何資料一經會員上載、傳送、輸入或提供至是方時，視為會員已允許是方無條件使用、修改、重製、公開播送、改作、散布、發行該等資料，並得將前述權利轉授權他人，會員對此絕無異議。會員並應保證是方使用、修改、重製、公開播送、改作、散布、發行、公開發表、轉授權該等資料，不致侵害任何第三人之智慧財產權，否則應對是方負起一切損害賠償責任。\n\n十一、拒絕或終止會員的使用\n會員同意是方得基於維護交易安全之考量，因任何合理理由，包含但不限於缺乏使用，或違反本服務條款的明文規定及精神，終止會員的密碼、帳號（或其任何部分）或本服務（或其任何部分）之使用，或將本服務內任何「會員內容」加以移除並刪除。此外，會員同意若本服務（或其任何部分）之使用被終止，是方對會員或任何第三人均不承擔任何明示、默示責任，或其衍生之任何直接或間接責任。\n\n十二、準據法與管轄法院\n因本服務條款所衍生之一切紛爭，雙方同意以中華民國法令為準據法，並合意以臺灣士林地方法院為第一審管轄法院。',
        privacyPolicy: '隱私權政策\n本網站是由「是方電訊股份有限公司」（下稱「是方電訊」）所經營；是方電訊十分重視您的隱私權。因此，是方電訊承諾尊重您的隱私，本網站不會主動要求您提供個人資料，如因您需要是方電訊向您進行業務聯繫而須取得您的個人資料時，是方電訊將對上述資訊加以保密。使用者如果對於是方電訊之隱私權聲明、或與個人資料有關之相關事項有任何疑問，可以聯繫是方電訊個人資料保護之專責人員電子信箱：tim_chiang@chief.com.tw，是方電訊將儘速回覆說明。\n\n一、 個人資料取得\n原則上，使用者進入是方電訊相關網站時，並不需要輸入個人資料，例如姓名或電子郵件地址等，除非明確告知，是方電訊不會在使用者不知情的情況下，取得使用者個人資料；是方電訊不會蒐集使用者之IP位址、Cookie，不主動追蹤、分析、紀錄使用者之網路瀏覽紀錄，但於必要情形下，經是方電訊於網站明顯之處揭示或以彈跳視窗予以告知使用者蒐集使用之目的並獲得使用者之同意者，不在此限。\n\n在某些情況下，例如當使用者要求加入會員、訂閱電子報、使用其他服務、或參加其他活動時，是方電訊相關網站或其合作對象可能需要使用者登錄個人資料，以便於和使用者聯繫、完成交易、提供服務、或處理訂閱程序；在此等情況下，是方電訊相關網站或其合作對象將明白告知使用者此等事實，如果使用者選擇不接收任何廣告或不願提供聯繫資訊，是方電訊將完全予以尊重。\n\n二、個人資料的利用\n是方電訊相關網站所取得之個人資料，都僅供是方電訊於其內部、依照原來所說明的使用目的和範圍加以使用，除非事先說明並取得同意、或依照相關法律規定，否則是方電訊不會將使用者個人資料提供給第三人、或移作其他目的使用。\n\n但在下列的情況下，依據電信管理法第九條第四項、個人資料保護法第二十條第一項、其他相關法令規定或下列各種情況，是方電訊有可能會查看或提供您的個人或相關電信資料給有權之行政或司法機關、機關團體或主張其權利受侵害並提出適當證明之第三人：\n1. 依法令規定、或依司法機關或其他有權機關團體的命令；\n2. 為執行本使用條款、或使用者違反使用條款；\n3. 為保護本服務系統之安全或經營者之合法權益；\n4. 為保護其他使用者或其他第三人之合法權益；\n5. 為維護本服務系統之正常運作。\n\n三、 資料安全\n是方電訊已取得ISO27001、27011、27017及27018 之資訊安全認證，將盡力以合理之技術及程序，保障您個人資料之安全。\n\n四、當事人權利\n使用者依據台灣之個人資料保護法且在不妨礙是方電訊履行原說明使用目的、範圍內得行使下列相關權利：查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理、利用、請求刪除。\n\n設籍歐盟之個人得依據歐盟個人資料保護規則且在不妨礙是方電訊履行原說明使用目的、範圍內得行使下列相關權利：資料可攜權、資料刪除權、被遺忘權、資料拒絕權、資料處理限制權、資料更正權。\n\n五、連結\n是方電訊相關網站或網頁都可能包含其他網站或網頁的連結，對於此等不屬於是方電訊之網站或網頁，不論關於其內容或隱私權政策，均與是方電訊無關。\n\n六、修訂\n是方電訊保留不定期更新本隱私權聲明之權利。\n ',
        agreementText: '為保障您的權益，請詳細閱讀本網站會員條款的所有內容。當您勾選「同意」選項時，即視為您已閱讀、知悉並同意遵守以上服務條款所訂之內容。'
      },
      pageResetPassword: {
        resetPassword: '重設密碼',
        confirm: '確認',
        confirmPasswordNotMatch: '密碼與確認密碼不相符!',
        successfully: '重設密碼完成',
        returnToLogin: '返回登入頁面',
        formFields: {
          password: '密碼',
          check_password: '確認密碼',
        },
      },
      pageSetPassword: {
        setPassword: '設定密碼',
        confirm: '確認',
        confirmPasswordNotMatch: '密碼與確認密碼不相符!',
        successfully: '設定密碼完成',
        goToLogin: '前往登入頁面',
        formFields: {
          password: '密碼',
          check_password: '確認密碼',
        },
      },
      pageProduct: {
        overview: '概觀',
        functions: '功能',
        price: '定價',
      },
    },
    console: {
      /** layout header */
      header: {
        home: '首頁',
        cloudPortal: 'Cloud Portal',
        contactUs: '聯絡我們',
        supports: '支援',
        myAccount: '我的帳戶',
        clientNumber: '客戶編號：',
        myInfo: '個人資料管理',
        myTicket: '我要報修',
        orderManage: '訂單管理',
        logout: '登出',
      },
      /** layout sidebar */
      sidebar: {
        /** level 1 group */
        iamManage: 'IAM管理',
        platform: '運算平臺',
        ccis: '資料儲存服務',
        nets: '網路',
        matrix: '資源監控',
        costInquery: '費用查詢',
        /** level 2 group */
        snapshot: '快照',
        netsManager: '網路管理',
        /** page link */
        iamUsers: 'IAM使用者',
        dashboard: '總覽',
        vmSetting: '虛擬機設定與操作',
        disk: '磁碟區',
        snapshotList: '快照',
        snapshotRule: '快照規則',
        vni: '網路介面(VNI)',
        firewall: '防火牆規則',
        balancer: '負載平衡',
        orderHistory: '查看調整記錄',
        purchaseCCIS: '合約調整',
        bucket: '儲存桶',
        usageReport: '用量報告',
        vpcNets: 'VPC網段',
        ccx: '串接其他CCX',
        matrixData: '查看使用數據',
        alarm: '告警',
        exCloud: '其他公有雲資源',
        valuation: '預估月費用',
        singleVM: 'Per VM',
        totalUsage: '資源使用量',
      },
      pageMyInfo: {
        enabled: '啟用',
        disabled: '停用',
        confirmTitle: '修改個人資料？',
        confirmText: '若確定要修改個人資料，請點擊下方確認按鈕。',
        cancelTitle: '放棄修改個人資料？',
        cancelText: '若確定要放棄修改個人資料，請點擊下方確認按鈕。',
        hintRoot: '請注意：若要修改基本資料請與是方客服人員聯繫!!',
        hintIAM: '請注意：若要修改基本資料請請用Root權限登入後再與是方客服人員聯繫!!',
        contact: '聯繫客服',
        submit: '送出',
        cancel: '取消',
        formFields: {
          identityNumber: '客戶統編',
          companyName: '客戶名稱',
          clientNumber: '客戶編號',
          twoFa: '2FA狀態',
          email: 'Email',
          pass0: '原始密碼',
          pass1: '修改密碼',
          pass2: '確認修改密碼',
        },
      },
      pageMyTicket: {
        title: '報修列表',
        actions: {
          createTicket: '新增報修單',
        },
        dataFields: {
          ticketNo: '報修單編號',
          contactName: '聯絡人',
          vmId: 'VM ID',
          ccisId: 'CCIS ID',
          ticketCode: '障礙代碼',
          ticketRemark: '障礙訊息',
          tkNumber: '報修單號碼：',
          tkStatus: '回應代碼：',
          tkHistory: '回應訊息：'
        },
        tkStatus: {
          CLOSE: '結案',
          NEW: '新立案',
          WAITING: '待結案',
          PROCESS: '處理中',
        },
      },
      pageCreateTicket: {
        title: '新增報修單',
        submit: '送出',
        cancel: '取消',
        none: '無',
        confirmTitle: '新增報修單？',
        confirmText: '若確定要新增報修單，請點擊下方確認按鈕。',
        formFields: {
          identityNumber: '客戶統編',
          companyName: '客戶名稱',
          clientNumber: '客戶編號',
          contactName: '聯絡人',
          contactMail: '聯絡人EMAIL',
          contactMobile: '聯絡人行動電話',
          contactTel: '聯絡人市話',
          vmId: 'VM ID',
          ccisId: 'CCIS ID',
          vmOrCcisRequired: 'VM與CCIS兩者必填其中一個',
          ticketCode: '障礙代碼',
          ticketRemark: '障礙訊息：',
          ticketRemarkHint: '若有多台虛擬機及CCIS同時報修，請在下方內容詳列',
          uploadImageHint: '若需要付上截圖，請在按下【確定】後取得報修單號碼，將相關截圖Mail至是方客服信箱：service@chief.com.tw並註明報修單號碼，謝謝!!',
        }
      },
      pageOrderManage: {
        title1: '歷史訂單列表',
        title2: '歷史訂單 列表',
        actions: {
          /** cancel order dialog */
          cancelOrder: '解約訂單',
          cancelOrderTitle: '確定解約訂單「{{id}}」嗎？',
          cancelOrderText1: '是否確認要解約「{{id}}」訂單？',
          cancelOrderText2: '請注意：解約後，年約訂單將轉為隨需訂單。',
          resUuid: '資源編號：{{resUuid}}',
          resType: '資源類型：{{resType}}',
          resTypeEnum: {
            vm: '虛擬機',
            ccis: 'CCIS',
          },
          orderEDate: '訂單到期日：{{orderEDate}}',
          password: '若確認要解約，請在下方文字框中輸入登入密碼確認',
          cancelOrderPassword: '請輸入密碼確認要刪除',
          /** convert order dialog */
          convertOrder: '轉換訂單',
          vmUuid: '請選擇欲轉換年約制之虛擬機',
          contractId: '請選擇合約期間',
          convertOrderText1: '是否確認要轉換成年約制訂單？',
          convertOrderText2: '請注意：轉換成年約制訂單後即不能再更改規格，也無法刪除，關機與重開等操作可正常使用，請在轉換前先確認好該虛擬機的規格再進行轉換!!',
          convertOrderText3: '若確認要轉換，請在下方文字框中輸入登入密碼確認',
          convertOrderPassword: '請輸入密碼確認要轉換(要加上一個解約-先預設訂單到期日)',
          /** other */
          submit: '送出',
          cancel: '取消',
          createOrder: '新增年約制訂單',
        },
        dataFields: {
          id: '訂單編號',
          resUuid: 'VM/CCIS UUID',
          resName: 'VM/CCIS 名稱',
          contractMonth: '合約期間',
          contractMonthText: '{{n}}個月',
          orderDate: '訂單開始日',
          orderEDate: '訂單到期日',
          status: '訂單狀態',
          statusEnum: {
            1: '正常',
            2: '即將到期',
            3: '已到期解約',
            4: '已刪除',
            5: '作廢',
            6: '已刪除未滿7日',
            7: '已解約未滿7日',
          },
        },
      },
      pageOrderCreate: {
        title1: '新增年約制訂單',
        title2: '建立年約制虛擬機',
        confirmTitle: '新增年約制虛擬機？',
        confirmText: '若確定要新增年約制虛擬機，請點擊下方確認按鈕。',
        submit: '送出',
        cancel: '取消',
        note: '修改防火牆時無法建立虛擬機',
        formFields: {
          contractId: '合約期間',
          comboId: '組合方案',
          comboNote1: '1. 年約制訂單一旦建立即無法更改規格也無法調整訂單內容，只能自己關機但無法刪除，若須調整需要聯絡客服。',
          comboNote2: '2. 年約制時間到會自動續約，若需解約請在即將到期時解約，已自動續約之訂單需要解約請聯絡客服。',
          tagName: '名稱 (Name Tag)',
          tagNamePlaceholder: '請輸入名稱與標籤(例：my-vm-gateway-01)',
          osName: '作業系統',
          osVersion: '作業系統版本',
          cpuCore: 'vCPU：',
          cpuCoreNote: '2-64 core CPU必須為偶數',
          core: 'Core',
          ramSize: '記憶體：',
          ramSizeNote: '4-256 GB 記憶體GB不得低於CPU數, 且不得大於CPU數之8倍',
          gb: 'GB',
          vpcId: 'VPC',
          createVPC: '建立VPC',
          firewallId: '防火牆',
          createSecurityGroup: '建立防火牆',
          isAutoAssignPublicIP: '自動指派公有IP',
          enableEnum: {
            'Y': '啟用',
            'N': '停用',
          },
          dataDisks: '設定儲存：',
          dataDisksNote: '預設「根磁碟區」作業系統最小需50GB。',
          improvedInfo: '進階資訊',
          hypervisorId: '平台',
          enableAutoRecover: '虛擬機自動復原',
          enableTerminationProtection: '終止保護',
          enableStopProtection: '停止保護',
        },
      },
      pageIAMManage: {
        title: 'IAM使用者列表',
        enabled: '啟用中',
        disabled: '停用中',
        actions: {
          createIAM: '新增IAM使用者',
          editIAM: '編輯IAM使用者',
          destroyIAM: '刪除IAM使用者',
          confirmDestroyTitle: '刪除IAM使用者？',
          confirmDestroyText: '確認您要「刪除IAM使用者」{{account}}？',
        },
        dataFields: {
          id: '帳號ID',
          account: '登入帳號',
          roles: '角色',
          email: 'EMAIL',
          lastSetPasswordDate: '最後修改密碼時間',
          lastLoginDate: '最後登入時間',
          enableTwoFactor: '2FA',
          isLock: '狀態',
        },
      },
      pageUpsertIAM: {
        accountPlaceholder: '請輸入登入帳號(僅接受英文字母不分大小寫與數字,點及底線)',
        passwordPlaceholder: '請輸入密碼(至少12碼含英文大小寫、數字與特殊符號)',
        confirmPasswordNotMatch: '密碼與確認密碼不相符！',
        enabled: '啟用',
        disabled: '停用',
        submit: '送出',
        cancel: '取消',
        formFields: {
          account: '登入帳號',
          email: '電子信箱',
          roles: '角色',
          enableTwoFactor: '開啟2FA',
          isLock: '狀態',
          password: '密碼',
          checkPassword: '確認密碼',
        },
        pageCreate: {
          title: '新增IAM使用者',
          confirmTitle: '新增IAM使用者？',
          confirmText: '若確定要新增IAM使用者，請點擊下方確認按鈕。',
        },
        pageEdit: {
          title: '編輯IAM使用者',
          confirmTitle: '更新IAM使用者？',
          confirmText: '若確定要更新IAM使用者，請點擊下方確認按鈕。',
        },
      },
      pageDashboard: {
        resource: '資源(用量資料待讀取約1分鐘後將正確顯示)',
        lastestAnnouncement: '最新公告',
        basicUsage: '限制預設基礎使用量',
        shortcut: '各功能快捷鍵',
        documents: '說明文件連結',
        resourceFields: {
          vm: '虛擬機',
          enable: '啟用',
          disable: '關閉',
          cpu: 'CPU',
          ram: '記憶體',
          ramUnit: 'GB',
          disk: '磁碟區',
          snapshot: '快照',
          loadBalancing: '負載平衡',
        },
        announcement: {
          publishDate: '發布日期：',
          closeDialog: '關閉視窗',
        },
        basicUsageFields: {
          baseVm: '虛擬機',
          baseBandwidth: '頻寬',
          baseCpu: 'CPU',
          baseMemory: '記憶體',
          baseVolume: '磁碟區',
          baseVpc: 'VPC',
          baseIp: '公有IP',
        },
        unit: {
          BASE_SPEC_UNIT_SET: '台',
          BASE_SPEC_UNIT_CORE: 'core',
          BASE_SPEC_UNIT_MB: 'MB',
          BASE_SPEC_UNIT_MBPS: 'Mbps',
          BASE_SPEC_UNIT_GB: 'GB',
          BASE_SPEC_UNIT_PCS: '個',
        },
        additionalInfo: '若需調整使用量可使用”我要報修”功能聯繫客服。'
      },
      pageVMSetting: {
        actions: {
          boot: '開機',
          shutdown: '關機',
          poweroff: '強制關機',
          adjustSpecification: '調整規格',
          reset: '重啟',
          destroy: '刪除',
          createVM: '建立虛擬機',
          instanceId: '虛擬機ID',
          confirmBootTitle: '啟動虛擬機？',
          confirmBootText: '若確定要啟動上述虛擬機，請點擊下方的確認按鈕。',
          confirmShutdownTitle: '停止虛擬機？',
          confirmShutdownText: '若確定要停止上述虛擬機，請點擊下方的確認按鈕。',
          confirmPoweroffTitle: '強制停止虛擬機？',
          confirmPoweroffText: '若確定要強制停止上述虛擬機，請點擊下方的確認按鈕。',
          confirmResetTitle: '重啟虛擬機？',
          confirmResetText: '若確定要重啟上述虛擬機，請點擊下方的確認按鈕。',
          confirmDestroyTitle: '刪除虛擬機？',
          confirmDestroyText: '若確定要刪除上述虛擬機，請點擊下方的確認按鈕。',
          adjustSpecificationTitle: '調整虛擬機規格「{{uuid}}」',
          submit: '送出',
          cancel: '取消',
        },
        dataFields: {
          action: '動作',
          templateOSName: '作業系統',
          uuid: 'VM-ID',
          specifications: '規格',
          status: '系統狀態',
          privateIP: '私有IP',
          publicIP: '公有IP',
          lastShutdownTime: '上次開關機時間',
          /** format */
          cpuCoresUnit: 'Core',
          ramSizeUnit: 'GB',
          statusEnum: {
            0: '關機',
            1: '啟動',
            2: '關機中',
            3: '開機中',
            4: '建立中',
            5: '更新中',
            6: '還原中',
            7: '錯誤',
          },
        },
        detail: {
          detailInfo: '詳細資訊',
          security: '安全性',
          web: '網路',
          storage: '儲存',
          monitor: '監控',
          tag: '標籤',
        },
        detailInfo: {
          instanceSummary: '虛擬機摘要',
          uuid: '虛擬機ID',
          cpuCores: 'CPU數量',
          templateUUID: 'CMI ID',
          publicIP: '公有IPv4地址',
          privateIP: '私有IPv4地址',
          ramSize: '記憶體大小',
          lastBootTime: '上次開機時間',
          alreadyBoot: '（已啟動：{{day}}天{{hour}}小時{{min}}分鐘）',
          hour: '小時',
          day: '天',
          status: '虛擬機狀態',
          templateOSType: '作業系統',
          templateOSName: '平台版本',
        },
        detailSecurity: {
          title: '防火牆規則列表',
          dataFields: {
            netUuid: 'VPC',
            firewallUuid: '防火牆規則ID',
            fwRuleUuid: '規則ID',
            fwrDirection: 'IN / OUT',
            fwrDirectionEnum: {
              1: 'Inbound',
              2: 'Outbound',
            },
            fwrIpVer: 'IPv4 / IPv6',
            fwrIpVerEnum: {
              1: 'IPv4',
              2: 'IPv6',
            },
            fwrType: '類型',
            fwrTypeEnum: {
              0: 'ALL',
              1: 'TCP',
              2: 'UDP',
              3: 'ICMP',
            },
            fwrPort: '連接埠範圍',
            cidrDest: 'IN:來源(白名單) OUT:目的地(黑名單)',
            fwrOperate: '操作',
            fwrOperateEnum: {
              0: 'Allow',
              1: 'Deny',
            },
            remark: '描述',
          },
        },
        detailWeb: {
          title: '網路詳細資訊',
          addVni: '新增網卡',
          deleteVni: '刪除網卡',
          publicIp: '公有 IPv4 地址',
          privateIpv6: 'IPv6 地址',
          privateIpv4: '私有IPv4 地址',
          vpcUuid: 'VPC ID',
          vniUuid: 'VNI ID',
          confirmDeleteVniTitle: '刪除網卡？',
          confirmDeleteVniText1: '確認您要刪除這張網卡？',
          confirmDeleteVniText2: '請選擇下方「確認按鈕」。',
          ip: 'IP',
          vpc: 'VPC',
          vni: 'VNI',
        },
        detailAddVNI: {
          title: '新增網卡',
          vpcId: 'VPC',
          fwId: '防火牆規則',
          create: '新增',
          back: '返回',
          confirmTitle: '新增網卡？',
          confirmText1: '網卡新增之後，因作業系統本身差異，可能需要在作業系統中自行配置網卡，如啟用網卡、啟用 DHCP、或指定 default gateway 等等。',
          confirmText2: '確認您要新增網卡？',
          confirmText3: '請選擇下方確認按鈕。',
        },
        detailStorage: {
          rootDiskInfo: '根裝置詳細資訊',
          rootDiskName: '根裝置名稱',
          dataDiskInfo: '區塊型儲存設備',
          dataFields: {
            diskUUID: '磁碟區 ID',
            diskName: '裝置名稱',
            diskSize: '磁碟區大小 (GiB)',
            diskSizeUnit: ' GB',
            diskSpeed: '磁碟區類型',
            diskSpeedEnum: {
              0: 'SSD',
              1: 'HDD',
            },
            vmUUID: '連接的虛擬機',
          },
        },
      },
      pageCreateVM: {
        title: '建立虛擬機',
        core: 'Core',
        gb: 'GB',
        createVPC: '建立VPC',
        createSecurityGroup: '建立防火牆',
        enable: '啟用',
        disable: '停用',
        addDataDisk: '新增磁碟區',
        diskType: '磁碟區類型',
        rootDisk: '根磁碟區',
        disk: '磁碟區',
        destroy: '刪除',
        formFields: {
          nameTag: '名稱與標籤',
          templateOsName: '作業系統',
          templateID: '作業系統版本',
          cpuCore: 'vCPU：',
          cpuCoreNote: '2-64 core CPU必須為偶數',
          cpuError: 'CPU數量必須是偶數',
          ramSize: '記憶體：',
          ramSizeNote: '4-256 GB 記憶體GB不得低於CPU數, 且不得大於CPU數之8倍',
          vpcID: 'VPC',
          vpcFirewallIDs: '防火牆',
          isAutoAssignPublicIP: '自動指派公有IP',
          dataDisks: '設定儲存：',
          dataDisksNote: '預設「根磁碟區」作業系統最小需 50 GB。',
          dataDisksNote2: '還原至新VM無法調整磁碟區容量及類型',
          osNote: '還原至新VM無法調整作業系統及版本',
          improvedInfo: '進階資訊',
          hypervisorId: '平台',
          enableAutoRecover: '虛擬機自動復原',
          enableTerminationProtection: '終止保護',
          enableStopProtection: '停止保護',
          enableEnum: {
            'Y': '啟用',
            'N': '停用',
          },
          enableEnumNote: '每台VM配置一個免費公有IP，如有需要請選擇啟用，VM建立將後無法移除或新增。'
        },
        submit: '送出',
        reset: '重設',
        confirmTitle: '建立虛擬機？',
        confirmText: '若確定要建立虛擬機，請點擊下方確認按鈕。',
        note: '修改防火牆時無法建立虛擬機',
      },
      pageDiskList: {
        title: '磁碟區清單',
        actions: {
          connectDisk: '連結磁碟區',
          adjustDisk: '調整磁碟區',
          adjustDiskTitle: '調整磁碟區「{{uuid}}」',
          adjustDiskLabel: '磁碟區容量/類型：',
          adjustDiskNote: '容量只能調大，若更換不同類型依容量大小需要3~7+天作業處理時間，完成後會另發Mail通知。',
          connectDiskTitle: '連結磁碟區「{{uuid}}」',
          connectVMLabel: '連結虛擬機（只能在關機狀態下）',
          dontConnectVM: '不連結虛擬機',
          confirmDestroyTitle: '刪除磁碟區？',
          diskId: '磁碟區ID',
          confirmDestroyText: '若確定要刪除上述磁碟區，請點擊下方的確認按鈕。',
          submit: '送出',
          cancel: '取消',
          createDisk: '新增磁碟區',
          destroyDisk: '刪除磁碟區',
          deleteDiskTitle: '刪除磁碟區「{{uuid}}」嗎？',
          deleteDiskNote1: '是否確認要刪除 {{uuid}} ?',
          deleteDiskNote2: '請注意：刪除後資料無法再復原!!',
          deleteDiskPasswordPlaceholder: '請輸入密碼確認要刪除磁碟區',
        },
        dataFields: {
          uuid: '磁碟區ID',
          diskSize: '磁碟區大小',
          diskSizeUnit: 'GB',
          diskSpeed: '磁碟區類型',
          diskSpeedEnum: {
            0: 'SSD',
            1: 'HDD',
          },
          vmStatus: '虛擬機狀態',
          vmStatusEnum: {
            0: '關機',
            1: '啟動',
            2: '關機中',
            3: '開機中',
            4: '建立中',
            5: '更新中',
            6: '錯誤',
          },
          vmUuid: '連接的虛擬機',
        },
      },
      pageCreateDisk: {
        title: '新增磁碟區',
        formFields: {
          diskName: '名稱(Name Tag)',
          diskSizeAndSpeed: '磁碟區容量/類型',
          diskSizeUnit: 'GB',
          diskSpeedEnum: {
            0: 'SSD',
            1: 'HDD',
          },
          instanceId: '連結虛擬機(只能在關機狀態下)',
          dontConnectDisk: '不連結虛擬機',
        },
        submit: '送出',
        cancel: '取消',
        confirmTitle: '建立磁碟區？',
        confirmText: '若確定要建立磁碟區，請點擊下方確認按鈕。',
      },
      pageSnapshot: {
        title: '快照列表',
        actions: {
          createSnapshot: '新增快照',
          destroySnapshot: '刪除快照',
          restoreToVM: '還原至VM',
          createToNewVM: '新增至新VM',
          confirmDestroyTitle: '刪除快照「{{name}}」嗎？',
          confirmDestroyText1: '是否確認要刪除 {{name}}？',
          confirmDestroyText2: '請注意：刪除後資料無法再復原!!',
          confirmRestoreTitle: '還原快照「{{name}}」至VMID「{{vm}}」嗎？',
          confirmRestoreText1: '是否確認要還原快照 {{name}} 至 {{vm}}？',
          confirmRestoreText2: '請注意：還原後將覆蓋現有資料，建議還原前再執行一次快照避免重要資料遺失!!',
        },
        dataFields: {
          uuid: '快照ID',
          snapshotSizes: '大小',
          vmUuid: 'VM ID',
          diskQty: '磁碟區數量',
          policyUuid: '規則ID',
          status: '快照狀態',
          statusEnum: {
            0: '待處理',
            1: '已完成',
            2: '還原中',
            6: '刪除中',
          },
          createDate: '快照時間',
        },
      },
      pageCreateSnapshot: {
        title: '新增快照',
        submit: '送出',
        cancel: '取消',
        confirmTitle: '新增快照？',
        confirmText: '若確定要新增快照，請點擊下方確認按鈕。',
        formFields: {
          instanceId: 'VM-ID',
          disks: '已連接磁碟區清單',
          diskID: '磁碟區ID',
          diskName: '裝置名稱',
          diskSize: '磁碟區大小(GiB)',
          diskSpeed: '磁碟區類型',
          name: '名稱 (Name Tag)',
        },
      },
      pageCreateSnapshotToNewVM: {
        title: '新增至新VM',
        submit: '送出',
        cancel: '取消',
        confirmTitle: '新增快照至新VM？',
        confirmText: '若確定要新增快照至新VM，請點擊下方確認按鈕。',
        formFields: {
          name: '名稱 (Name Tag)',
        },
      },
      pageSnapshotRule: {
        title: '快照規則列表',
        actions: {
          editSnapshotRule: '修改快照規則',
          destroySnapshotRule: '刪除快照規則',
          confirmDestroyTitle: '刪除快照規則「{{uuid}}」嗎？',
          confirmDestroyText: '是否確認要刪除快照規則 {{uuid}}？',
          createSnapshotRule: '新增快照規則',
        },
        dataFields: {
          uuid: '規則ID',
          policyName: 'Name',
          vmUuid: 'VM ID',
          vQty: 'Volumn Qty',
          createDate: '建立時間',
        },
      },
      pageUpsertSnapshotRule: {
        createSnapshotRule: '新增快照規則',
        editSnapshotRule: '修改快照規則',
        submit: '送出',
        cancel: '取消',
        formFields: {
          instanceId: 'VM-ID',
          vmUuid: 'VM-ID',
          instanceIdPlaceholder: '請選擇虛擬機',
          policyName: '快照規則名稱',
          policyCycle: '頻率',
          policyCycleEnum: {
            '0': '半天',
            '1': '每天',
            '2': '每星期',
          },
          cycleWeekEnum: {
            '1': '星期一',
            '2': '星期二',
            '3': '星期三',
            '4': '星期四',
            '5': '星期五',
            '6': '星期六',
            '7': '星期日',
          },
          qtyRule: '過期條件',
          qtyLimit1: '保留',
          qtyLimit2: '個快照',
        },
      },
      pageOrderHistory: {
        title: '調整紀錄列表',
        contract: '現有合約',
        confirm: '確定',
        reserve: '預約合約',
        records: '調整記錄',
        recordsNote: '(只包括已生效的合約。不含預約合約)',
        dataFields: {
          orderId: '訂單編號',
          month: '合約期間',
          monthText: '{{n}}個月',
          beginDate: '合約起始日',
          expireData: '合約到期日',
          commit: 'Commit量',
          commitText: '{{n}} GB',
          autoExtend: '自動續約',
          autoExtendEnum: {
            'Y': 'Yes',
            'N': 'No',
          },
          modifyDate: '調整日期',
        },
      },
      pagePurchaseCCIS: {
        title: '合約期間與容量調整',
        note1: '1. 所設定的容量將於合約生效時進行調整。',
        note2: '2. 年約制時間到會自動續約，若需解約請在即將到期時解約，已自動續約之訂單需要解約請聯絡客服。',
        note3: '3. 若以上不符合您的需求請透過”我要報修”功能聯絡客服，並在障礙訊息欄位輸入需求。',
        note4: '4. 每一個主帳號最高容量為100TB。(合約期間內總Commit量，若有超出100TB以上需求請透過”我要報修”功能聯絡客服。)',
        contact: '聯絡客服',
        submit: '送出',
        cancel: '取消',
        successfulMessage: '購買成功！',
        formFields: {
          resourceItemId: '合約期間',
          blockSize: '容量：',
          blockSizeNote: '目前容量{{commit}}GB，最小{{minSize}}GB，單位間距：100GB',
          blockSizeUnit: 'GB',
          autoExtend: '自動續約',
        },
      },
      pageUsageReport: {
        title: '用量報告',
        sizeTitle: '已使用空間總計',
        sizeNote: '單位：MB',
        itemTitle: '物件總數',
        itemNote: '所有儲存桶的資料夾及檔案總合（單位：個）',
      },
      pageVNI: {
        title: '網路介面(VNI)清單',
        actions: {
          adjustNetSegment: '調整網段',
          adjustNetSegmentTitle: '調整網段 ({{uuid}})',
          noFirewallNotify: '該VPC 沒有綁定防火牆，請綁定完成再進行轉移VNI！',
        },
        dataFields: {
          vniUuid: 'VNI ID',
          vmUuid: 'VM ID',
          fwUuid: '防火牆規則ID',
          vpcUuid: 'VPC ID',
          cidrIpv4: 'VNI-所屬網段',
          publicIp: '公網IP',
          privateIpv4: '私網IP',
        },
      },
      pageFirewall: {
        title: '防火牆規則列表',
        actions: {
          createFirewall: '新增防火牆規則',
          editFirewall: '修改防火牆規則',
          destroyFirewall: '刪除防火牆規則',
          confirmDestroyTitle: '刪除防火牆規則？',
          confirmDestroyText1: '確認您要「刪除防火牆規則」，而且無法連接到任何資源？',
          confirmDestroyText2: '要永久刪除 {{firewallId}} 嗎？無法復原此動作。',
          alertDestroyTitle: '刪除防火牆規則必須沒有關聯任何虛擬機',
          alertDestroyText1: '要「刪除防火牆規則」必須沒有關聯任何虛擬機，',
          alertDestroyText2: '請先將要刪除的防火牆規則取消關聯虛擬機才能執行刪除。',
          note: 'Status非[錯誤提示、可編輯]以外皆不可編輯',
        },
        dataFields: {
          firewallUuid: '防火牆規則ID',
          fwCount: '規則計數',
          vpcName: 'VPC',
          vms: '關聯的虛擬機',
          status: '狀態',
          statusEnum: {
            '-1': '底層錯誤，請使用者重新檢查規則在度送出，或是尋找客服協助',
            '1': '建立VM 使用中',
            '5': '更新中',
            '6': '刪除中',
            '7': '可編輯',
          },
        },
      },
      pageUpsertFirewall: {
        contact: '聯絡客服',
        submit: '送出',
        cancel: '取消',
        remove: '刪除',
        addRule: '新增規則',
        portHint: '請注意：TCP/UDP 連接埠範圍可輸入單一數字、","分隔多個數字，或使用 "-" 表示區間，例如 80,443,3000-4000。防火牆更新時間隨防火牆規則數量和關聯虛擬機數量遞增。Rule筆數限制500筆。',
        formFields: {
          firewallName: '防火牆規則名稱',
          vpcId: 'VPC',
          vpcName: 'VPC',
          ruleId: '規則ID',
          fwrDirection: 'IN / OUT',
          fwrIpVer: 'IPv4 / IPv6',
          fwrType: '類型',
          fwrPort: '連接埠範圍',
          fwrPortPlaceholder: '請輸入連接埠範圍',
          cidrDest: 'CIDR',
          cidrDestIn: 'IN:來源(白名單)',
          cidrDestOut: 'OUT:目的地(黑名單)',
          fwrOperate: '操作',
          remark: '描述',
          remarkPlaceholder0: '請輸入描述',
          remarkPlaceholder1: '預設全關',
          remarkPlaceholder2: '預設全開',
        },
        errors: {
          notEmpty: '{{0}}不可為空！',
          port0: '規則類型為ALL時，連接埠範圍必須為Any',
          port1: '規則類型為TCP時，連接埠範圍必須為 1~65535，可輸入單一數字、逗號分隔或區間格式',
          port2: '規則類型為UDP時，連接埠範圍必須為 1~65535，可輸入單一數字、逗號分隔或區間格式',
          port3: '規則類型為ICMP時，連接埠範圍必須為-1',
        },
        pageCreate: {
          title: '新增防火牆規則',
          confirmTitle: '新增防火牆規則？',
          confirmText: '若確定要新增防火牆規則，請點擊下方確認按鈕。',
        },
        pageEdit: {
          title: '修改防火牆規則',
          confirmTitle: '修改防火牆規則？',
          confirmText: '若確定要修改防火牆規則，請點擊下方確認按鈕。',
        },
      },
      pageBalancer: {
        title: '負載平衡清單',
        yes: '是',
        no: '否',
        actions: {
          createBalancer: '新增負載平衡',
          editBalancer: '編輯負載平衡',
          destroyBalancer: '刪除負載平衡',
          confirmDestroyTitle: '刪除負載平衡？',
          confirmDestroyText1: '確認您要「刪除負載平衡」，而且無法連接到任何資源？',
          confirmDestroyText2: '要永久刪除 {{name}} 嗎？無法復原此動作',
        },
        dataFields: {
          lbType: '種類',
          lbName: '名稱',
          lbProtocol: 'Protocol',
          lbPort: 'Port',
          lbUrl: '域名',
          lbCertificate: '憑證',
          vpcUuid: 'VPC ID',
          vmUuid: 'VM ID',
          lbHealthCheck: 'Health Check',
          lbXforwardedfor: 'X-forwarded-for',
        },
      },
      pageUpsertBalancer: {
        submit: '送出',
        cancel: '取消',
        yes: '是',
        no: '否',
        uploadedFile: '已上傳檔案',
        errors: {
          lbPort: 'Port必須為1~65535的數字',
        },
        formFields: {
          lbType: '選擇種類',
          lbName: '名稱',
          lbProtocol: 'Protocol',
          lbPort: 'Port',
          lbUrl: '域名',
          lbCertificate: '憑證(if HTTPS)',
          vpcId: 'VPC',
          lbHealthCheck: 'Health Check',
          lbXforwardedfor: 'X-forwarded-for',
          vmId: '目標VM ID',
        },
        pageCreate: {
          title: '新增負載平衡',
          confirmTitle: '新增負載平衡？',
          confirmText: '若確定要新增負載平衡，請點擊下方確認按鈕。',
        },
        pageEdit: {
          title: '修改負載平衡',
          confirmTitle: '修改負載平衡？',
          confirmText: '若確定要修改負載平衡，請點擊下方確認按鈕。',
        },
      },
      pageBucket: {
        title: '儲存桶列表',
        actions: {
          createBucket: '建立儲存桶',
          emptyBucket: '清空儲存桶',
          deleteBucket: '刪除儲存桶',
        },
        dataFields: {
          name: '儲存桶名稱',
          namePlaceholder: '只能英數字',
          isPublic: '公開存取權限',
          isPublicEnum: {
            public: '公開',
            private: '封鎖',
          },
          size: '目前使用量',
          createDate: '建立日期',
        },
        emptyDialog: {
          title: '清空儲存桶「{{bucketName}}」所有物件嗎？',
          text1: '清空儲存桶-永久刪除儲存桶 {{bucketName}} 中的所有物件？',
          text2: '請注意：',
          text3: '清空儲存桶會刪除儲存桶中的所有物件，而且無法復原！',
          text4: '在清空儲存桶動作進行期間，新增至儲存桶的物件可能會被刪除。',
          text5: '若確認要清空，請在下方文字框中輸入登入密碼：',
          pwPlaceholder: '請輸入密碼確認要清空儲存桶',
        },
        deleteDialog: {
          title: '確認刪除儲存桶「{{bucketName}}」嗎？',
          text1: '確認永久刪除儲存桶 {{bucketName}} ？',
          text2: '請注意：',
          text3: '刪除儲存桶無法復原！',
          text4: '儲存桶名稱是唯一的，如果刪除此儲存桶，則可能為他人使用。',
          text5: '若確認要刪除，請在下方文字框中輸入登入密碼：',
          pwPlaceholder: '請輸入密碼確認要刪除儲存桶',
        },
        deleteDeniedDialog: {
          title: '儲存桶「{{bucketName}}」無法刪除！',
          text1: '儲存桶 {{bucketName}} 有資料無法刪除，只能刪除已清空的儲存桶！',
          text2: '請注意：',
          text3: '若要刪除儲存桶，必須將儲存桶內的所有物件清空。',
          text4: '若要刪除儲存桶中的所有物件，請先使用清空儲存桶。',
        },
        objectCreateDialog: {
          title: '新增資料夾',
          formFields: {
            name: '資料夾名稱',
            namePlaceholder: '資料夾名稱只能英數字，不可包含/',
          },
        },
        objectDeleteDialog: {
          title: '確認刪除此物件？',
          text1: '刪除的指定物件無法復原。',
          text2: '系統會刪除指定資料夾內的所有物件。',
          text3: '在刪除物件動作進行期間，新增至這些資料夾內的物件可能會被刪除。',
        },
        objectCopyMoveDialog: {
          copyTitle: '複製物件',
          moveTitle: '移動物件',
          notify: '資料夾不允許複製或移動到當前資料夾或其子資料夾',
          formFields: {
            bucketName: '目的地儲存桶名稱',
            prefix: '目的地資料夾',
          },
        },
        objectRenameDialog: {
          title: '重新命名指定物件',
          formFields: {
            name: '請輸入更改的名稱',
          },
        },
        objectUrlDialog: {
          title: '查看連結點',
          text: '查看「{{name}}」連結點：',
        },
        objectPresignedUrlDialog: {
          title: '預先簽章URL共用',
          copyUrl: '複製網址',
          formFields: {
            name: '連結名稱',
            expiration: '有效時間',
            expirationUnit: '(單位：分)',
            url: '分享連結',
          },
        },
        lifecycleUpsertDialog: {
          createTitle: '新增物件週期',
          updateTitle: '修改物件週期',
          formFields: {
            tagKey: 'Tag - Key',
            tagValue: 'Tag - Value',
            prefix: 'Prefix',
            prefixPlaceholder: '請輸入前綴字元',
            expiration: 'Expiration',
            expirationPlaceholder: '請輸入正整數並大於0',
            expirationUnit: '天',
            enabled: 'Enabled',
            enabledEnum: {
              enabled: '啟用',
              disabled: '關閉',
            },
          },
        },
        lifecycleDeleteDialog: {
          title: '刪除物件週期？',
          text: '確定您要刪除週期，而且無法復原此動作。',
        },
        detail: {
          objectActions: '物件操作',
          bucketInfo: '查看資訊',
          permission: '設定權限',
          bucketUsage: '查看用量',
          objectLifecycle: '物件週期',
          apiSecretKey: 'api密鑰',
        },
        detailObjects: {
          title: '物件操作列表',
          actions: {
            createFolder: '新增資料夾',
            uploadFile: '上傳檔案',
            delete: '刪除',
            copy: '複製',
            move: '移動',
            rename: '重新命名',
            url: '查看存取點',
            presignedUrl: '預先簽章URL共用',
          },
          dataFields: {
            name: 'Name',
            backToUpperFolder: '回上一層',
            size: 'Sizes',
            type: 'Type',
            lastModified: 'Last Modified',
          },
        },
        detailLifecycle: {
          title: '物件週期列表',
          actions: {
            create: '新增物件週期',
            update: '修改物件週期',
            delete: '刪除物件週期',
          },
          dataFields: {
            tag: 'Tag',
            prefix: 'Prefix',
            expiration: 'Expiration',
            enabled: 'Enabled',
            enabledEnum: {
              enabled: '啟用',
              disabled: '關閉',
            },
          },
        },
        detailSecretKey: {
          title: '查看API密鑰',
          name: 'Name',
          accessKey: 'Access Key ID',
          secretAccessKey: 'Secret Access Key',
        },
      },
      pageVPCNet: {
        title: 'VPC網段 列表',
        actions: {
          editVPCNet: '編輯VPC網段',
          editRouteRule: '編輯路由規則',
          destroyVPCNet: '刪除VPC網段',
          confirmDestroyTitle: '刪除VPC網段？',
          confirmDestroyText1: '確認您要「刪除VPC網段」，而且無法連接到任何資源？',
          confirmDestroyText2: '要永久刪除 {{netUuid}} 嗎？無法復原此動作。',
          createVPCNet: '新增VPC網段',
        },
        dataFields: {
          netName: 'VPC名稱',
          netUuid: 'VPC ID',
          status: '狀態',
          statusEnum: {
            0: '處理中',
            1: '正常',
            6: '刪除中',
          },
          routeLevel: '路由等級',
          routeLevelEnum: {
            1: '白金',
            2: '專業',
          },
          chargeMode: '計費模式',
          chargeModeEnum: {
            1: '固定制',
            2: '九五制',
            3: '總量制',
          },
          bandwidthLimit: '頻寬限制(M/bps)',
          cidrIpv4: 'IPv4 CIDR',
          cidrIpv6: 'IPv6 CIDR',
          cidrIpv6Enum: {
            'none': '無',
            '-1': '待配置',
          },
          vmNum: '關聯VM數',
        },
      },
      pageCreateVPCNet: {
        title: '新增VPC網段',
        formFields: {
          sourceTypeLabel1: '要建立的資源',
          sourceTypeLabel2: '僅建立VPC資源或VPC等。',
          sourceTypeEnum: {
            1: '僅限VPC',
          },
          vpcNameLabel1: '名稱 (Name Tag）',
          vpcNameLabel2: '建立標籤，其中索引鍵為\'Name\'和值為您指定的值。',
          vpcNamePlaceholder: '例：正式環境',
          cidrIpv4Label1: 'IPv4 CIDR區塊',
          cidrIpv4Label2: '手動輸入IPv4 CIDR (不可重覆）',
          cidrIpv4Placeholder: '10.0.0.0',
          cidrIpv6Label1: 'IPv6 CIDR區塊',
          cidrIpv6Label2: '請選擇IPv6 CIDR區塊。',
          cidrIpv6Enum: {
            'null': '無IPv6 CIDR區塊',
            '-1': '由是方提供的IPv6 CIDR區塊',
          },
          bandwidthLimit: '頻寬限制 (Mb)',
          bandwidthLimitPlaceholder: '限 1 ～ 500',
          routeLevel: '路由等級',
          routeLevelEnum: {
            1: '白金',
            2: '專業',
          },
          routeLevelMemo: '路由等級 (白金 / 專業)，專業為一般性Internet，若您希望中國大陸之使用者能正常存取您的服務，可選擇白金，費用差異請查看費率說明。',
          chargeMode: '計費模式',
          chargeModeEnum: {
            1: '固定制',
            2: '九五制',
            3: '總量制',
          },
        },
        needBeCidrIpv4: '必須為合法的IPv4 CIDR區塊！',
        submit: '送出',
        cancel: '取消',
        confirmTitle: '建立VPC網段？',
        confirmText: '若確定要建立VPC網段，請點擊下方確認按鈕。',
      },
      pageEditVPCNet: {
        title: '編輯VPC網段',
        formFields: {
          netName: '名稱',
          netNamePlaceholder: '例：正式環境',
          chargeMode: '計費模式',
          chargeModeEnum: {
            1: '固定制',
            2: '九五制',
            3: '總量制',
          },
          bandwidthLimit: '頻寬限制 (Mb)',
          bandwidthLimitPlaceholder: '限 1 ～ 500',
        },
        submit: '送出',
        cancel: '取消',
        confirmTitle: '編輯VPC網段？',
        confirmText: '若確定要編輯VPC網段，請點擊下方確認按鈕。',
      },
      pageEditNetRoute: {
        title: '編輯路由規則',
        formFields: {
          cidrDest: '目的地',
          targetTypeEnum: {
            0: 'Manual',
            1: 'Local',
            2: 'Default',
            3: 'VPC',
          },
          targetType: '目標',
          pleaseSelectVPC: '請選擇VPC',
          target: '目標',
          destroy: '刪除',
        },
        addRoute: '新增路由規則',
        submit: '送出',
        cancel: '取消',
        confirmTitle: '編輯路由規則？',
        confirmText: '若確定要儲存當前編輯的路由規則，請點擊下方確認按鈕。',
      },
      pageCCXList: {
        title: 'CCX申請資料列表',
        actions: {
          createCCX: '新增CCX',
        },
        dataFields: {
          clientNumber: '主帳號ID',
          ccxType: '平台',
          ccxTypeEnum: {
            1: 'AWS',
            2: 'GCP',
            3: 'Azure',
            4: 'CCX',
          },
          pairKey: 'AWS ID / Service Key / Pair Key / CCX ID',
          createDate: '申請日期',
          status: '狀態',
          statusEnum: {
            0: 'available',
            1: 'ordering',
            2: 'done',
          },
          vpcName: 'VPC',
        },
      },
      pageCreateCCX: {
        title: '新增CCX',
        formFields: {
          ccxType: '公有雲平台',
          ccxTypeEnum: {
            1: 'AWS',
            2: 'GCP',
            3: 'Azure',
            4: 'CCX',
          },
          pairKeyLabelEnum: {
            1: 'AWS ID',
            2: '配對金鑰Pair Key',
            3: '服務金鑰Service Key',
            4: 'CCX ID',
          },
          vpcId: 'VPC',
        },
        submit: '送出',
        cancel: '取消',
        confirmTitle: '建立CCX？',
        confirmText: '若確定要新增CCX，請點擊下方確認按鈕。',
      },
      pageSingleVM: {
        noVmData: '查無虛擬機資料！',
        title1: 'Per VM',
        title2: '使用數據',
        filterItem: '選擇指標',
        itemEnum: {
          'CPU usage%': 'CPU usage%',
          'Memory usage GB/MB': 'Memory usage GB/MB',
          'Status': 'Status',
          'Volume Read': 'Volume Read',
          'Volume Write': 'Volume Write',
          'Network in': 'Network in',
          'Network out': 'Network out',
        },
        filterVM: '虛擬機',
        pleaseSelectVM: '請選擇虛擬機',
        query: '查詢',
        time15min: '15分',
        time1hour: '1小時',
        time12hour: '12小時',
        time1day: '1天',
        on: '開機',
        off: '關機',
      },
      pageTotalUsage: {
        title: '資源使用量 數據',
        filterItem: '選擇指標',
        query: '查詢',
        time15min: '15分',
        time1hour: '1小時',
        time12hour: '12小時',
        time1day: '1天',
      },
      pageAlarm: {
        title: '告警列表',
        actions: {
          createAlarm: '新增告警',
          manualAlarm: '手動告警',
          editAlarm: '修改告警',
          destroyAlarm: '刪除告警',
          confirmManualTitle: '手動告警',
          confirmManualText1: '確認您要手動告警「{{id}}」？',
          confirmManualText2: '手動告警會立即將狀態改成警示中，並發MAIL給相關人員。',
          confirmDestroyTitle: '刪除本筆告警',
          confirmDestroyText1: '確認您要刪除告警「{{id}}」？',
          confirmDestroyText2: '要永久刪除「{{id}}」嗎？無法復原此動作。',
          submit: '送出',
          cancel: '取消',
        },
        dataFields: {
          alarmId: '告警ID',
          item: '指標名稱',
          uuid: 'VM ID',
          critical: '告警條件/臨界點',
          displayCritical: '{{point}} {{number}}',
          continuance: '持續時間',
          displayContinuance: '{{n}} 個資料點',
          coolDownTime: '報警後冷卻時間',
          displayCoolDownTime: '{{n}} 分',
          status: '狀態',
          statusEnum: {
            0: '正常',
            1: '警示中',
            2: '資料不足',
          },
          lAlarmTime: '上一次告警時間',
        },
      },
      pageUpsertAlarm: {
        create: '新增',
        edit: '修改',
        title: '{{action}}告警',
        formFields: {
          itemId: '選擇指標',
          instanceId: '選擇虛擬機',
          critical: '設定臨界點',
          criticalPoint: '選擇臨界點條件',
          criticalPointEnum: {
            '>': '大於(>)',
            '>=': '大於等於(>=)',
            '<': '小於(<)',
            '<=': '小於等於(<=)',
          },
          criticalNumber: '請輸入臨界點的值，只能輸入正整數字',
          otherCondition: '其他觸發條件',
          continuance: '請輸入持續時間(單位：XX個資料點)，只能輸入正整數字',
          coolDownTime: '請輸入告警後冷卻時間(單位：分)，只能輸入正整數字',
          emails: '通知對象',
          emailsNote: '通知對象：MAIL為主帳號或IAM User登入帳號之Email清單(最多10個)',
          destroy: '刪除',
          addEmail: '新增通知對象',
        },
        cancel: '取消',
        submit: '送出',
        confirmTitle: '{{action}}告警？',
        confirmText: '若確定要{{action}}告警，請點擊下方確認按鈕。',
      },
      pageExCloud: {
        title: '公有雲憑證 列表',
        actions: {
          destroy: '刪除憑證',
          create: '新增憑證',
          confirmDestroyTitle: '刪除憑證',
          confirmDestroyText1: '確認您要刪除「{{type}}」憑證？',
          confirmDestroyText2: '此動作確認後無法復原。',
        },
        dataFields: {
          publicCloudType: '平台',
          publicCloudTypeEnum: {
            1: 'AWS',
            2: 'GCP',
            3: 'Azure',
          },
          id: 'Access Key ID / API Key / 應用程式識別碼',
          secret: 'Secret Access Key / 應用程式密碼',
          directoryId: '目錄識別碼',
          subscriptionId: '訂閱帳戶識別碼',
          createDate: '建立時間',
        },
        detail: {
          awsTitle: 'AWS虛擬機列表',
          gcpTitle: 'GCP虛擬機列表',
          azureTitle: 'Azure虛擬機列表',
          region: '區域',
          displayALL: '顯示全部',
          awsDataFields: {
            region: '區域',
            vmName: 'VM名稱',
            vmUuid: 'VM ID',
            vmStatus: 'VM狀態',
            vmCombo: 'VM規格',
            vmPublicIp: 'VM Public IP',
            vmPrivateIp: 'VM Private IP',
            vmOpenTime: 'VM開機時間(UTC)',
            subscriptionAccount: '訂用帳戶',
            resourceGroup: '資源群組',
            vmOs: '作業系統',
            vmSizes: '大小',
            vmDisk: '磁碟',
            vmVni: 'VM所屬網段之ID',
          },
          gcpDataFields: {
            status: '狀態',
            name: '名稱',
            deletionProtection: 'Deletion Protection',
            zone: '區域',
            creationTime: 'Creation Time',
            machineType: 'Machine Type',
            preservedStateSize: 'Preserved state size',
            recommendations: 'Recommendations',
            inUseBy: 'In Use by',
            internalIp: 'Internal IP',
            externalIp: 'External IP',
          },
          azureDataFields: {
            vmName: '名稱',
            vmType: '類型',
            subscriptionAccount: '訂用帳戶',
            resourceGroup: '資源群組',
            region: '位置',
            vmStatus: '狀態',
            vmOs: '作業系統',
            vmSizes: '大小',
            vmPublicIp: '公用IP位址',
            vmDisk: '磁碟',
          },
        },
      },
      pageCreateExCloud: {
        title: '新增憑證',
        placeholderPrefix: '請輸入該公有雲申請之{{fieldName}}',
        formFields: {
          publicCloudType: '公有雲平台',
          publicCloudTypeEnum: {
            1: 'AWS',
            2: 'GCP',
            3: 'Azure',
          },
          accessKeyId: 'Access Key ID',
          secretAccessKey: 'Secret Access Key',
          apiKey: 'API Key',
          directoryId: '目錄識別碼',
          applicationId: '應用程式識別碼',
          subscriptionId: '訂閱帳戶識別碼',
          applicationPwd: '應用程式密碼',
        },
        submit: '送出',
        cancel: '取消',
        confirmTitle: '建立憑證？',
        confirmText: '若確定要憑證，請點擊下方確認按鈕。',
      },
      pageValuation: {
        title: '預估月費用',
        titleNote: '以前一天之資源使用情形預估月總費用，當資源異動頻繁時，將產生較大落差，實際金額以帳單為主。',
        totalCost: '月預估總費用',
        vmCost: '虛擬機',
        ccisCost: 'CCIS',
        vmDetail: '前一天虛擬機明細',
        ldate: '日期',
        vms: '總虛機數',
        cpus:'總CPU',
        rams: '總RAM',
        disks: '總DISK',
        bandwidth: '總Network Bandwith',
        images: '總收費Image數',
        ccisDetail: '前一天CCIS明細',
        commit:'Commit量',
        actual: '最大使用量',
        overQty: '總超出量 (GB * 1小時)',
        unit: {
          g: 'G',
          m: 'M',
          gb: 'GB',
        },
      },
      WorkInProgressText1: '本網頁目前施工中',
      WorkInProgressText2: '☆敬請期待☆',
    },
    /** form */
    form: {
      /** placeholder */
      pleaseInput: '請輸入{{fieldName}}',
      pleaseUpload: '請上傳{{fieldName}}',
      /** multiple select */
      multipleSelectItems: '{{n}}個物件被選擇',
      /** captcha input */
      inputCaptcha: '請輸入圖形中的小寫英數字母',
      changeAnother: '換一個',
      /** file upload input */
      errorFileType: '不正的檔案格式！',
      /** phone input */
      pleaseInputPhone3: '分機',
      /** file input */
      preview: '預覽',
      countries: {
        afghanistan: 'Afghanistan',
        albania: 'Albania',
        algeria: 'Algeria',
        americansamoa: 'American Samoa',
        andorra: 'Andorra',
        angola: 'Angola',
        anguilla: 'Anguilla',
        antarctica: 'Antarctica',
        antiguaandbarbuda: 'Antigua and Barbuda',
        argentina: 'Argentina',
        armenia: 'Armenia',
        aruba: 'Aruba',
        australia: 'Australia',
        austria: 'Austria',
        azerbaijan: 'Azerbaijan',
        bahamas: 'Bahamas',
        bahrain: 'Bahrain',
        bangladesh: 'Bangladesh',
        barbados: 'Barbados',
        belarus: 'Belarus',
        belgium: 'Belgium',
        belize: 'Belize',
        benin: 'Benin',
        bermuda: 'Bermuda',
        bhutan: 'Bhutan',
        bolivia: 'Bolivia',
        bosnia: 'Bosnia and Herzegovina',
        botswana: 'Botswana',
        brazil: 'Brazil',
        britishindianoceanterritory: 'British Indian Ocean Territory',
        britishvirginislands: 'British Virgin Islands',
        brunei: 'Brunei',
        bulgaria: 'Bulgaria',
        burkinafaso: 'Burkina Faso',
        burma: 'Myanmar',
        burundi: 'Burundi',
        cambodia: 'Cambodia',
        cameroon: 'Cameroon',
        canada: 'Canada',
        capeverde: 'Cape Verde',
        caymanislands: 'Cayman Islands',
        centralafricanrepublic: 'Central African Republic',
        chad: 'Chad',
        chile: 'Chile',
        china: 'China',
        christmasisland: 'Christmas Island',
        cocoskeelingislands: 'Cocos Islands',
        colombia: 'Colombia',
        comoros: 'Comoros',
        congo: 'Republic of the Congo',
        congodemocraticrepublic: 'Democratic Republic of the Congo',
        cookislands: 'Cook Islands',
        costarica: 'Costa Rica',
        croatia: 'Croatia',
        cuba: 'Cuba',
        curacao: 'Curacao',
        cyprus: 'Cyprus',
        czechrepublic: 'Czech Republic',
        denmark: 'Denmark',
        djibouti: 'Djibouti',
        dominica: 'Dominica',
        dominicanrepublic1: 'Dominican Republic',
        dominicanrepublic2: 'Dominican Republic',
        dominicanrepublic3: 'Dominican Republic',
        easttimor: 'East Timor',
        ecuador: 'Ecuador',
        egypt: 'Egypt',
        elsalvador: 'El Salvador',
        equatorialguinea: 'Equatorial Guinea',
        eritrea: 'Eritrea',
        estonia: 'Estonia',
        ethiopia: 'Ethiopia',
        falklands: 'Falkland Islands',
        faroeislands: 'Faroe Islands',
        fiji: 'Fiji',
        finland: 'Finland',
        france: 'France',
        frenchpolynesia: 'French Polynesia',
        gabon: 'Gabon',
        gambia: 'Gambia',
        georgia: 'Georgia',
        germany: 'Germany',
        ghana: 'Ghana',
        gibraltar: 'Gibraltar',
        greece: 'Greece',
        greenland: 'Greenland',
        grenada: 'Grenada',
        guam: 'Guam',
        guatemala: 'Guatemala',
        guernsey: 'Guernsey',
        guinea: 'Guinea',
        guineabissau: 'Guinea-Bissau',
        guyana: 'Guyana',
        haiti: 'Haiti',
        honduras: 'Honduras',
        hongkong: 'Hong Kong',
        hungary: 'Hungary',
        iceland: 'Iceland',
        india: 'India',
        indonesia: 'Indonesia',
        iran: 'Iran',
        iraq: 'Iraq',
        ireland: 'Ireland',
        isleofman: 'Isle of Man',
        israel: 'Israel',
        italy: 'Italy',
        ivorycoast: 'Ivory Coast',
        jamaica: 'Jamaica',
        japan: 'Japan',
        jersey: 'Jersey',
        jordan: 'Jordan',
        kazakhstan: 'Kazakhstan',
        kenya: 'Kenya',
        kiribati: 'Kiribati',
        kosovo: 'Kosovo',
        kuwait: 'Kuwait',
        kyrgyzstan: 'Kyrgyzstan',
        laos: 'Laos',
        latvia: 'Latvia',
        lebanon: 'Lebanon',
        lesotho: 'Lesotho',
        liberia: 'Liberia',
        libya: 'Libya',
        liechtenstein: 'Liechtenstein',
        lithuania: 'Lithuania',
        luxembourg: 'Luxembourg',
        macau: 'Macau',
        macedonia: 'Macedonia',
        madagascar: 'Madagascar',
        malawi: 'Malawi',
        malaysia: 'Malaysia',
        maldives: 'Maldives',
        mali: 'Mali',
        malta: 'Malta',
        marshallislands: 'Marshall Islands',
        mauritania: 'Mauritania',
        mauritius: 'Mauritius',
        mayotte: 'Mayotte',
        mexico: 'Mexico',
        micronesia: 'Micronesia',
        moldova: 'Moldova',
        monaco: 'Monaco',
        mongolia: 'Mongolia',
        montenegro: 'Montenegro',
        montserrat: 'Montserrat',
        morocco: 'Morocco',
        mozambique: 'Mozambique',
        namibia: 'Namibia',
        nauru: 'Nauru',
        nepal: 'Nepal',
        netherlands: 'Netherlands',
        netherlandsantilles: 'Netherlands Antilles',
        newcaledonia: 'New Caledonia',
        newzealand: 'New Zealand',
        nicaragua: 'Nicaragua',
        niger: 'Niger',
        nigeria: 'Nigeria',
        niue: 'Niue',
        northernmarianaislands: 'Northern Mariana Islands',
        northkorea: 'North Korea',
        norway: 'Norway',
        oman: 'Oman',
        pakistan: 'Pakistan',
        palau: 'Palau',
        palestine: 'Palestine',
        panama: 'Panama',
        papuanewguinea: 'Papua New Guinea',
        paraguay: 'Paraguay',
        peru: 'Peru',
        philippines: 'Philippines',
        pitcairnislands: 'Pitcairn',
        poland: 'Poland',
        portugal: 'Portugal',
        puertorico1: 'Puerto Rico',
        puertorico2: 'Puerto Rico',
        qatar: 'Qatar',
        reunion: 'Reunion',
        romania: 'Romania',
        russia: 'Russia',
        rwanda: 'Rwanda',
        saintbarthelemy: 'Saint Barthelemy',
        samoa: 'Samoa',
        sanmarino: 'San Marino',
        saotomeandprincipe: 'Sao Tome and Principe',
        saudiarabia: 'Saudi Arabia',
        senegal: 'Senegal',
        serbia: 'Serbia',
        seychelles: 'Seychelles',
        sierraleone: 'Sierra Leone',
        singapore: 'Singapore',
        sintmaarten: 'Sint Maarten',
        slovakia: 'Slovakia',
        slovenia: 'Slovenia',
        solomonislands: 'Solomon Islands',
        somalia: 'Somalia',
        southafrica: 'South Africa',
        southkorea: 'South Korea',
        southsudan: 'South Sudan',
        spain: 'Spain',
        srilanka: 'Sri Lanka',
        sthelena: 'Saint Helena',
        stkitts: 'Saint Kitts and Nevis',
        stlucia: 'Saint Lucia',
        stmartin: 'Saint Martin',
        stpierre: 'Saint Pierre and Miquelon',
        stvincent: 'Saint Vincent and the Grenadines',
        sudan: 'Sudan',
        suriname: 'Suriname',
        svalbard: 'Svalbard and Jan Mayen',
        swaziland: 'Swaziland',
        sweden: 'Sweden',
        switzerland: 'Switzerland',
        syria: 'Syria',
        taiwan: 'Taiwan',
        tajikistan: 'Tajikistan',
        tanzania: 'Tanzania',
        thailand: 'Thailand',
        togo: 'Togo',
        tokelau: 'Tokelau',
        tonga: 'Tonga',
        trinidadandtobago: 'Trinidad and Tobago',
        tunisia: 'Tunisia',
        turkey: 'Turkey',
        turkmenistan: 'Turkmenistan',
        turksandcaicos: 'Turks and Caicos Islands',
        tuvalu: 'Tuvalu',
        uae: 'United Arab Emirates',
        uganda: 'Uganda',
        uk: 'United Kingdom',
        ukraine: 'Ukraine',
        uruguay: 'Uruguay',
        usa: 'United States',
        uzbekistan: 'Uzbekistan',
        vanuatu: 'Vanuatu',
        vatican: 'Vatican',
        venezuela: 'Venezuela',
        vietnam: 'Vietnam',
        virginislands: 'U.S. Virgin Islands',
        wallisandfutuna: 'Wallis and Futuna',
        westernsahara: 'Western Sahara',
        yemen: 'Yemen',
        zambia: 'Zambia',
        zimbabwe: 'Zimbabwe',
      },
    },
    /** validation */
    validation: {
      notEmpty: '不可為空!',
      needBeFormat: '必須為{{format}}格式!',
      needBePhone: '必須為電話格式!',
      needBePersonId: '必須為中華民國身分證字號格式!',
      needBeCompanyId: '必須為中華民國公司統一編號格式!!',
      needBePersonIdOrCompanyId: '必須為中華民國身分證字號或公司統一編號格式!',
      needBeHost: '必須為IPv4、IPv6或domain格式!',
      needBeSerialString: '必須為英文、數字、-或_組成的字串!',
      needBeInteger: '必須為整數!',
      needBeIntegerOrEmpty: '必須為空或整數!',
      needBeNumberInRange: '必須為{{min}}~{{max}}的數字!',
      needBeNumberGreaterThan: '必須為大於{{min}}的數字!',
      hasMaxDecimal: '小數點後最多輸入{{max}}位數字！',
      hexStringInRange: '{{min}}~{{max}}的十六進位數字',
      needBeHexNumber: '必須為十六進位數字!',
      needBeHexNumberStringInRange: '必須為{{min}}~{{max}}的十六進位數字字串!',
      hexNumberStringInRange: '{{min}}~{{max}}的十六進位數字字串',
      needBeStringInRange: '必須為長度在{{min}}~{{max}}之間的字串!',
      needBeStringExclude: '必須為不包含「{{character}}」的字串!',
      needBeAlphaNumeric: '必須為英文或數字組成的字串!',
      needBeChineseAlphaNumeric: '必須為中文、英文或數字組成的字串!',
      needBeAccount: '必須為英文或數字或.@_-等字元組成的字串!',
      needBePassword: '必須為12~32位，包含大小寫英文、數字及特殊符號字元所組成的字串!',
      needBeIpV4Range: '必須為IPV4(區段)!',
      needBeStringListSplitByCommaOrNewLine: '必須為以逗號或換行分隔的項目列表字串!',
      needBeIntegerOrIntegerRangeStringListSplitByComma: '必須為以逗號或換行分隔的整數或整數區段字串，且每個數字(或區段)皆需在{{min}}到{{max}}之間!',
      needBeS3Bucket: '必須為3~63位，包含小寫英文、數字及-字元所組成的字串!',
      needBeS3Folder: '包含大小寫英文、數字所組成的字串!',
      startTimeCannotBeLaterThanEndTime: '起始時間不可晚於結束時間!',
      cantSelectSelf: '不可選擇自己!',
    },
    /** table */
    table: {
      totalItems: '資料總筆數：{{items}}',
      configDialogTitle: '設定表格',
      rowsPerPage: '每頁顯示筆數',
      infinityRowsPerPage: '不分頁',
      reOrderDescription: '拖曳欄位可調整欄位順序',
      name: '欄位名稱',
      width: '寬度',
      hidden: '隱藏',
      saveConfigure: '儲存設定',
      cancel: '取消設定',
      action: '動作'
    },
    /** notify */
    notify: {
      submitSuccess: '送出成功!',
      createSuccess: '新增成功!',
      updateSuccess: '更新成功!',
      deleteSuccess: '刪除成功!',
      confirmDestroy: '確定要删除{type}「{{name}}」？',
      confirm: '確定',
      cancel: '取消',
    },
    /** tooltip */
    tooltip: {
      copyToClipboardDone: '已複製至剪貼簿！',
    },
    /** confirm dialog */
    confirmDialog: {
      confirm: '確認',
      cancel: '取消',
    },
    /** tags manager */
    tagsManager: {
      manageTags: '管理標籤',
      tagId: '標籤鍵',
      tagIdPlaceholder: '請輸入標籤鍵',
      tagIdError1: '標籤鍵不可為空！',
      tagIdError2: '標籤鍵不可為「id」！',
      tagIdError3: '標籤鍵最大長度為50個字元！',
      tagValue: '標籤值',
      tagValuePlaceholder: '請輸入標籤值',
      tagValueError1: '標籤值最大長度為50個字元！',
      addTag: '新增標籤',
      destroy: '刪除',
      submit: '送出',
      cancel: '取消',
    },
    /** api error */
    apiError: {
      error401: '使用者權限不足',
      error403: '為了您的帳戶安全，系統已自動登出',
      needRelogin: '登入已逾時!',
      unexpectedServerError: '未預期的伺服器錯誤!',
      API_SERVER_ERROR: '未預期的API Server錯誤！',
      CAPTCHA_NOT_MATCH: '驗證碼錯誤！',
      /* 常用訊息相關(10000-19999) */
      TRY_AGAIN_LATER: '操作太過頻繁，請稍候再試！',
      EMAIL_NOT_EXIST: 'Email不存在！',
      EMAIL_REPEAT: '已經存在相同的重複Email！',
      MISSING_DATA: '缺少必須的資料！',
      USER_DOES_NOT_HAVE_PERMISSION: '使用者沒有權限！',
      DB_HAS_NO_DATA: 'DB沒有資料！',
      EMAIL_REGISTERED: '此郵件已註冊過或註冊審核中！',
      LINK_EXPIRED: '連結逾期！',
      NETWORK_ERROR: '網路異常！',
      /* 帳號密碼相關(20000-29999) */
      LOGIN_ERROR: '帳號或密碼有誤！',
      ACCOUNT_NOT_ACTIVATED: '此帳號尚未啟用！',
      PASSWORD_AGAINST_RULES: '設置的密碼複雜度不符合規則！',
      PASSWORD_CANNOT_RESET: '不能重設密碼！',
      PASSWORD_RESET_REPEAT:  '使用者已於24小時之內申請過重設密碼！',
      PASSWORD_RESET_EXPIRED: '重設密碼申請已過期！',
      PASSWORD_EXPIRED: '設定密碼時效失效',
      PROCESS_APPLY_REPEAT: '使用者已於24小時之內申請過註冊進度查詢！',
      PROCESS_APPLY_EXPIRED: '註冊進度查詢申請已過期！',
      REGISTER_VERIFY_ERROR: '註冊驗證錯誤！',
      REGISTER_APPLIED: '此帳號申請資料已在審核中！',
      INCORRECT_PASSWORD: '密碼有誤！',
      VERIFY_CODE_ERROR: '驗證碼錯誤！',
      REPEAT_LOGIN: '重複登入！',
      CAN_NOT_FIND_2FA: '驗證碼錯誤！',
      /* 權限相關(40000~49999) */
      ACCOUNT_ROLE_NOT_EXIST: '此帳號沒有相關角色！',
      YOU_ARE_NOT_DEFAULT_ASSISTANT: '你不是預設助理！',
      /* 虛擬機相關(50000~50999) */
      VM_STATUS_ERROR: '虛擬機狀態錯誤！',
      VM_NOT_FOUND: '找不到虛擬機！',
      /* 磁碟區相關(51000-51999) */
      DISK_STATUS_ERROR: '磁碟區狀態錯誤！',
      DISK_NOT_FOUND: '找不到磁碟區！',
      DISKS_LIMIT_3: '資料碟上限3個！',
      NON_REMOVABLE_ROOT_DISK: '不可移除根磁碟區！',
      UNABLE_TO_REDUCE_DISK_SIZE: '磁碟區容量只能調大！',
      DISK_ALREADY_HAS_A_VM_ATTACHED: '此磁碟區已有連結虛擬機！',
      OVER_VM_DISK_LIMIT: '超過虛擬機磁碟容量限制！',
      /* 網段相關(52000-52999) */
      VPC_ALREADY_HAS_A_VM_ATTACHED: '此VPC有虛擬機正連結中！',
      /* 防火牆相關(53000-53999) */
      FIREWALL_ALREADY_HAS_A_VM_ATTACHED: '防火牆已有連結虛擬機！',
      /* 快照相關(54000-54999) */
      SNAPSHOT_STATUS_ERROR: '快照狀態錯誤！',
      /* MV Cloud 相關(6000-60100) */
      PUBLIC_CLOUD_REPEAT: '已有此憑證，請先刪除舊憑證後再新增憑證！',
      PUBLIC_CLOUD_NOT_EXIST: '公有雲憑證不存在！',
      PUBLIC_CLOUD_MISSING_PARAMETERS_GCP: 'GCP 資料不全！',
      PUBLIC_CLOUD_MISSING_PARAMETERS_AZURE: 'AZURE 資料不全！',
      PUBLIC_CLOUD_MISSING_PARAMETERS_AWS: 'AWS 資料不全！',
      /* AmazonS3相關(70000-70999) */
      AMAZON_SERVICE_ERROR: 'S3發生錯誤！',
      BUCKET_NOT_EMPTY: '儲存桶未清空！',
      INVALID_ACCESS_KEY_ID: '無效的Access Key ID！',
      KEY_TOO_LONG: '物件路徑過長！',
      NO_SUCH_BUCKET: '儲存桶不存在！',
      NO_SUCH_KEY: '物件不存在！',
      /* 儲存桶相關(71000-71999) */
      ILLEGAL_BUCKET_NAME: '儲存桶名稱不符合規則',
      INVALID_DIRECTORY: '無效的路徑！',
      LIFECYCLE_RULE_NOT_FOUND: '物件週期不存在！',
      /* 驗證相關(90000~) */
      TWO_FA_CODE_ERROR: '2fa驗證碼錯誤！',
      VERIFY_DATA_ERROR: '驗證資料錯誤！',
      VERIFY_REGISTER_ASSIGN_ERROR: '驗證註冊簽核流程指派錯誤！',
      VERIFY_REGISTER_REJECT_ERROR: '驗證註冊簽核流程拒絕錯誤！',
      VERIFY_REGISTER_SIGN_FLOW_SIGN_PERSON_ERROR: '當前簽核人不符！',
      VERIFY_REGISTER_AGREE_ERROR: '驗證註冊簽核流程同意錯誤！',
      NOT_HAVE_EMAIL: '2fa 開啟 但 沒有 Email！',
      EMAIL_DOES_NOT_CONFORM_TO_NORMALIZATION: 'Email 不符合正規化！',
      PASSWORDS_DO_NOT_MATCH: '第二次輸入的密碼與第一次不同！',
      ACCOUNT_HAS_BEEN_DELETED: '該帳號已被刪除！',
      ACCOUNT_EXISTS: '帳號已存在！',
      EMAIL_EXISTS: 'Email 已存在！',
      NOT_HAVE_PASSWORD: '沒有輸入密碼！',
      FIELD_MUST_FILL_IN: '欄位必填！',
      FORMAT_ERROR: '格式錯誤！',
      ACCOUNT_FORMAT_ERROR: '帳號只接受英文、Dot、UnderLine！',
      MISS_PARAMETER: '沒有資料傳送進來！',
      TIME_IS_ERROR: '輸入月份不符合要求！',
      STATUS_IS_ERROR: '輸入狀態不符合要求！',
      PRICE_IS_ERROR: '定價欄位缺少資料！',
      TEMPLATEID_IS_ERROR: '此母版不存在資料庫中！',
      CATEGORYID_IS_ERROR: '此資源類型不存在資料庫中！',
      NAME_AND_SPECTYPE_UNIQUE_IS_ERROR: '相同的 名稱與類型 不能重複定價！',
      SPECTYPE_TEMPLATE_UNIQUE_IS_ERROR: '母版不能被重複定價！',
      TEMPLATE_STATUS_ERROR: '虛擬機母版狀態錯誤！',
      TEMPLATE_ALREADY_EXISTS: '虛擬機母版已存在！',
      USER_NUMBER_EXISTS: '員工編號已存在！',
      OVER_BASE_USAGE: '超過基礎使用量！',
      PHONE_FORMAT_ERROR: '手機號碼不符合正規化！',
      IPv4_FORMAT_ERROR: 'IP格式錯誤！',
      FIREWALL_IN_NON_MODIFIABLE_STATE: '防火牆處於不可修改狀態！',
      FIREWALL_OVER_LIMIT: '防火牆超過數量限制！',
      CCIS_HOST_ERROR: '儲存平台異常，請稍後再試！',
      CCIS_EXPEND_BLOCKSIZE_ERROR: '儲存空間加購失敗，請稍後再試！',
      CCOS_USER_NOT_FOUND: '儲存空間查無此用戶，請連繫客服！',
      DATE_MUST_GREATER_THAN_TODAY: '日期必須大於今天！',
      VPC_ALREADY_EXISTS: 'VPC網段已存在！',
      CCIS_ERROR: 'CCIS 出錯了！',
      CLIENT_NOT_FOUND: '找不到用戶！',
      CLIENT_NUMBER_NOT_FOUND: '此用戶編號查無資料！',
      ACCOUNT_DISABLE: '帳號被停用！',
      ACCOUNT_DELETE: '帳號被禁用！',
      CCIS_PURCHASE_TOO_OFTEN: '儲存空間一天只允許購買一次！',
      CCIS_PURCHASE_FULL: '可購額度已滿！',
      DEALER_NOT_FOUND: '找不到經銷商！',
      ACCOUNT_IS_LOCK: '帳號被鎖定，請聯繫Root管理員！',
      CCIS_CHANGE_NAME_DUPLICATED: '新名稱不可與現有物件同名！',
      CCIS_PERIOD_MUST_BE_LONGER: '容量不變，合約周期必須更長！',
      CCIS_NEW_END_MUST_AFTER_OLD_END: '調高容量時，新約截址日必須晚於舊約截止日！',
      CCIS_REDUCE_ON_LAST_MONTH: '只能在合約截止前30天調降容量，並於合約截止次日生效！',
      CCIS_GET_TOKRN_FAIL: '儲存服務登入失敗！',
      CCIS_SET_BLOCKSIZE_FAIL: '調整容量失敗！',
      CCIS_GET_BLOCKSIZE_FAIL: '讀取容量失敗！',
      CCIS_SOMETHING_WRONG: '儲存服務異常！',
      MANUAL_METHOD_REQUIRES_THE_USE_OF_THE_IPv4_FORMAT: '使用Manual方式，須使用IPv4格式！',
      YEARLY_VM_CANNOT_ADJUST: '年約制虛擬機不能調整規格！',
      VM_NEED_SHUTDOWN: '虛擬機需要關機！',
      A_VM_CAN_ONLY_BE_BOUND_TO_ONE_SNAPSHOT_RULE: '一台VM 只能綁定一個 快照規則！',
    },
  },
};
